import { Button } from 'antd';
import { ReportsAccessProvider } from '../../../lib/ReportsAccessContext';
import ReportsSearch from '../../navigation/ReportsSearch';
import { SearchOutlined } from '@ant-design/icons';
import ToolkitsSearch from '../../navigation/ToolkitsSearch';
const searchComponentByType = {
  reports: ({
    contextWrap,
    ...props
  }) => contextWrap ? <ReportsAccessProvider children={<ReportsSearch {...props} />} /> : <ReportsSearch {...props} />,
  toolkits: ToolkitsSearch
};
const Search = ({
  searchType,
  isCollapsed,
  setCollapsed,
  ...props
}) => {
  const Component = searchComponentByType[searchType];
  return isCollapsed ? <Button type="ghost" size="large" style={{
    width: '100%'
  }} onClick={() => setCollapsed(false)} icon={<SearchOutlined style={{
    fontSize: 24
  }} />} /> : <Component {...props} />;
};
export default Search;